// extracted by mini-css-extract-plugin
module.exports = {"container":"SubShipmentTrackingOrder_container__1PlPB"};